import { GET_FACILITIES_ME_REQUESTED } from "./type";

export const getFacilitiesMeRequested = (token: string) => {
  return {
    type: GET_FACILITIES_ME_REQUESTED,
    token
  };
};
